import { produce } from 'immer';

import { UpdateImportExportWizardLock } from '../../actions/importExportWizard/updateImportExportWizardLock';
import { ImportExportWizardState } from '../../typings/importExportWizard';

export function updateImportExportWizardLock(
    state: ImportExportWizardState,
    action: UpdateImportExportWizardLock
): ImportExportWizardState {
    return produce(state, draft => {
        draft.isLocked = action.isLocked;
    });
}
